import { Component, OnInit } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from '.../../environments/environment';
import { Broadcaster } from '.../../environments/broadcaster';

import { LoaderService } from 'app/_services/loader.service';
import { utils, write, WorkBook } from 'xlsx';
import { saveAs } from 'file-saver';
import Swal from 'sweetalert2'
import * as moment from 'moment';
import { AuthService } from 'app/_services/auth.service';
declare var $: any;
@Component({
    selector: 'itAsset',
    templateUrl: './itAsset.component.html',
})




export class ItAssetComponent {
    
    public inventoryType:any;
    showLoader: boolean;  



    //  ADD INVENTORY VARIABLE 

    public item :any;
    public date :any;
    public totalitem :any;
    public purchaseFrom :any;
    public requirmentFrom :any;
    public location :any;

    // ERRORR MESSAGE VARIABLE


    public itemEr :any;
    public dateEr :any;
    public totalitemEr :any;
    public purchaseFromEr :any;
    public requirmentFromEr :any;
    public locationEr :any;



     
    Inventory = [
        { id: 1, name: 'Laptop' },
        { id: 2, name: 'Laptop Charger' },
        { id: 3, name: 'LAN & MAC Address' },
        { id: 4, name: 'Laptopn Bag' },
        { id: 5, name: 'Mouse' },
        { id: 6, name: 'Thermal Printer' },
        { id: 7, name: 'Charger' },
        { id: 8, name: 'Battery' }
    ];


    constructor(private http: HttpClient, private broadcaster: Broadcaster, private auth: AuthService, private loaderService: LoaderService) {
        this.loaderService.status.subscribe((val: boolean) => {
          this.showLoader = val;
        });
        
      }
    
    
    addNewInventory(){
         
        $("#addModal").modal("show");
        
    }

    



    saveNewInventory(){
      
       //item
       if (this.item == null || this.item == undefined || this.item == "" || this.item == "null") {
           this.itemEr = true;
           return;
       } else {
        this.itemEr = false;
       }
       //date
       if (this.date == null || this.date == undefined || this.date == "" || this.date == "null") {
        this.itemEr = true;
        return;
       } else {
        this.dateEr = false;
       }
       //totalitemm
       if (this.totalitem == null || this.totalitem == undefined || this.totalitem == "" || this.totalitem == "null") {
        this.totalitemEr = true;
        return;
       } else {
        this.totalitemEr = false;
       }
       //purchaseFrom
       if (this.purchaseFrom == null || this.purchaseFrom == undefined || this.purchaseFrom == "" || this.purchaseFrom == "null") {
        this.purchaseFromEr = true;
        return;
       } else {
        this.purchaseFromEr = false;
       }
       //requirmentFrom
      if (this.requirmentFrom == null || this.requirmentFrom == undefined || this.requirmentFrom == "" || this.requirmentFrom == "null") {
        this.requirmentFromEr = true;
        return;
      } else {
          this.requirmentFromEr = false;
         }

      //location
      if (this.location == null || this.location == undefined || this.location == "" || this.location == "null") {
            this.locationEr = true;
            return;
      } else {
            this.locationEr = false;
        }
       
        
    }





   
}







// WEBPACK FOOTER //
// ./src/app/superAdmin/users/itAsset.component.ts